'use client'

import React, { useContext } from 'react'
import { getDefaultConfig, useFetchTemplates } from '@api/templates'
import Grid from '@ui/Grid'
import { BuilderContext } from '../utils'
import { produce } from 'immer'
import { Button } from 'antd'
import { TemplateInterface } from '@interfaces/templates'
import BuilderSide from '@components/BuilderSide/BuilderSide'
import Widget from '@ui/Widget'
import IconButton from '@ui/IconButton'
import { AiOutlineCheck } from 'react-icons/ai'
import styled from 'styled-components'
import { Color } from '@interfaces/designSystem'

const Img = styled.img`
  width: 263px;
  height: auto;
`

const BuilderTemplateSide = () => {
  const { data: templates } = useFetchTemplates()

  const { widget, setWidget } = useContext(BuilderContext)

  const onChangeTemplate = async (template: TemplateInterface) => {
    try {
      const config = await getDefaultConfig(template.id)

      setWidget(
        produce(widget, draft => {
          draft.template = template
          draft.config.style = { ...template.globalStyle }
          draft.config.cards.forEach((card, i) => {
            const defaultCard = config.cards[i]
            card.style = { ...template.cardsStyle, ...(defaultCard?.style || {}) }

            if (defaultCard?.icon) {
              card.icon = defaultCard.icon
            }
          })
          if (draft.config.mobilePlansSwitch) {
            draft.config.mobilePlansSwitch.style = { ...template.mobileSwitcherStyle }
          }
        }),
      )
    } catch (e) {
      setWidget(
        produce(widget, draft => {
          draft.template = template
          draft.config.style = { ...template.globalStyle }
          draft.config.cards.forEach(card => {
            card.style = { ...template.cardsStyle }
          })
          if (draft.config.mobilePlansSwitch) {
            draft.config.mobilePlansSwitch.style = { ...template.mobileSwitcherStyle }
          }
        }),
      )
    }
  }

  return (
    <BuilderSide>
      <Grid gap={16}>
        {templates?.map(item => (
          <Widget
            key={item.id}
            title={item.name}
            cursor="pointer"
            onClick={() => {
              onChangeTemplate(item)
            }}
            border={`1px solid ${
              widget.template?.id === item.id ? Color.Blue_50 : 'transparent'
            }`}
            actions={[
              widget.template?.id === item.id ? (
                <IconButton
                  icon={AiOutlineCheck}
                  size="small"
                  iconSize={14}
                  key={1}
                  type="primary"
                >
                  Selected
                </IconButton>
              ) : (
                <Button
                  key={2}
                  size="small"
                  onClick={() => {
                    onChangeTemplate(item)
                  }}
                >
                  Select
                </Button>
              ),
            ]}
          >
            <Img src={`/img/templates/${item.id}.png`} />
          </Widget>
        ))}
      </Grid>
    </BuilderSide>
  )
}

export default BuilderTemplateSide
